import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error("Please enter your email"); return; }
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Something went wrong");
    } finally { setBusy(false); }
  };

  return (
    <div className="container-luxe section-pad max-w-md" data-testid="forgot-page">
      <p className="overline">Reset your password</p>
      <h1 className="font-display text-4xl md:text-5xl text-aubergine leading-[1.1] mt-3">Forgot your password?</h1>
      <p className="mt-3 text-plumSoft leading-relaxed">No worries — enter your email and we&rsquo;ll send you a secure reset link valid for the next 60 minutes.</p>

      {sent ? (
        <div className="mt-8 rounded-2xl bg-white border border-aubergine/[0.08] p-6">
          <p className="font-display text-xl text-aubergine">Check your inbox</p>
          <p className="mt-2 text-plumSoft text-sm leading-relaxed">
            If <b className="text-aubergine">{email}</b> is registered with WOWSHE, you&rsquo;ll receive an email shortly with a link to reset your password.
          </p>
          <Link to="/login" className="mt-5 inline-block text-[11px] uppercase tracking-widest text-plum hover:text-aubergine">← Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 card-luxe p-8 space-y-5">
          <div>
            <label className="label-luxe">Email</label>
            <input data-testid="fp-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-luxe" placeholder="you@example.com" />
          </div>
          <button data-testid="fp-submit" disabled={busy} className="btn-primary w-full">{busy ? "Sending…" : "Send reset link"}</button>
        </form>
      )}

      <p className="text-sm text-plumSoft mt-6 text-center font-light">
        Remembered it? <Link to="/login" className="text-plum">Back to sign in</Link>
      </p>
    </div>
  );
}
